import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import { styled } from '@mui/material/styles'
import { HeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'

type RefreshButtonProps = {
  onClick: () => void
  disabled?: boolean
}

const StyledIcon = styled(RefreshRoundedIcon)({
  color: colorPalette.monotone[4],
  fontSize: '16px',
})

export const RefreshButton = ({ onClick, disabled }: RefreshButtonProps) => {
  return (
    <HeaderIconButton onClick={onClick} disabled={disabled}>
      <StyledIcon />
    </HeaderIconButton>
  )
}
